import Swiper from "swiper";
import { Navigation } from "swiper/modules";

class BrandGallery {
  constructor(element) {
    this.element = element[0];

    this.swiperElement = this.element.querySelector(
      "[data-brand-gallery-swiper]",
    );

    this.previousButton = this.element.querySelector(
      "[data-brand-gallery-prev]",
    );

    this.nextButton = this.element.querySelector("[data-brand-gallery-next]");

    this.type = this.element.dataset.brandGalleryType;

    if (!this.swiperElement) {
      return;
    }

    this.init();
  }

  init() {
    const isPreview = this.type === "preview";

    this.swiper = new Swiper(this.swiperElement, {
      modules: [Navigation],

      slidesPerView: isPreview ? 1.15 : "auto",
      spaceBetween: 16,
      speed: 600,
      watchOverflow: true,

      navigation: {
        prevEl: this.previousButton,
        nextEl: this.nextButton,
      },

      breakpoints: isPreview
        ? {
            768: {
              slidesPerView: 2.15,
              spaceBetween: 16,
            },
            992: {
              slidesPerView: 4,
              spaceBetween: 16,
            },
          }
        : {},
    });
  }
}

export default BrandGallery;
